import { z } from 'zod';

const envSchema = z.object({
  // Supabase (required)
  VITE_SUPABASE_URL: z.string().url('Invalid Supabase URL'),
  VITE_SUPABASE_ANON_KEY: z.string().min(1, 'Supabase anon key is required'),
  VITE_SUPABASE_PROJECT_ID: z.string().min(1, 'Project ID is required'),
  
  // Sentry (optional but recommended)
  VITE_SENTRY_DSN: z.string().url('Invalid Sentry DSN').optional(),
  
  // reCAPTCHA (optional)
  VITE_RECAPTCHA_SITE_KEY: z.string().optional(),
});

export type Env = z.infer<typeof envSchema>;

export function validateEnv(): Env {
  try {
    return envSchema.parse(import.meta.env);
  } catch (error) {
    if (error instanceof z.ZodError) {
      const missingVars = error.errors.map(err => `- ${err.path.join('.')}: ${err.message}`).join('\n');
      
      console.error('❌ Environment validation failed:\n', missingVars);
      
      // Show user-friendly error in development
      if (import.meta.env.DEV) {
        document.body.innerHTML = `
          <div style="font-family: monospace; padding: 20px; background: #fee; border: 2px solid #c00;">
            <h1 style="color: #c00;">⚠️ Configuration Error</h1>
            <p>Required environment variables are missing or invalid:</p>
            <pre style="background: #fff; padding: 10px; border-radius: 4px;">${missingVars}</pre>
            <p>Please check your <code>.env</code> file.</p>
          </div>
        `;
      }
      
      throw new Error('Environment validation failed. Check console for details.');
    }
    throw error;
  }
}
